import { render, staticRenderFns } from "./ReceivingAddress.vue?vue&type=template&id=9982a3d0&scoped=true&"
import script from "./ReceivingAddress.vue?vue&type=script&lang=js&"
export * from "./ReceivingAddress.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingAddress.vue?vue&type=style&index=0&id=9982a3d0&lang=scss&scoped=true&"
import style1 from "./ReceivingAddress.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9982a3d0",
  null
  
)

export default component.exports